
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import ECWalletHistory from "@/components/ecwallet/ECWalletHistory.vue";
import ECWalletReload from "@/components/ecwallet/ECWalletReload.vue";
import ProductGCBalances from "@/components/productgc/ProductGCBalances.vue";

export default defineComponent({
  name: "ecwallethistory",
  components: {
    ECWalletHistory,
    ECWalletReload,
    ProductGCBalances,
  },
  data() {
    return {
      isOverriden: false,
    };
  },
  mounted() {
    if (localStorage.getItem("override_cifid") != null) {
      this.isOverriden = true;
    }
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Online Shop");
    });
  },
});
